import {setShouldAutoArrange} from 'common/src/modules/campaigns/store/campaignLogic/campaignLogic.slice';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {CampaignSetupAgentToolName} from '../../../campaignSetupAgent.enums';

export default function autoArrangeCardsTool(store: CLStore) {
  return tool({
    name: CampaignSetupAgentToolName.AutoArrangeCards,
    description: 'Auto-arrange cards in the campaign decision tree',
    displayName: 'Auto-arranging cards',
    inputSchema: z.object({}),
    execute: async () => {
      store.dispatch(setShouldAutoArrange(true));

      return toolResult('done');
    },
  });
}
